@let controlValue = control();
@if (controlValue) {
  <mat-form-field appearance="outline" class="form-field">
    <mat-label>{{label()}}</mat-label>
    <input matInput [formControl]="controlValue" [placeholder]="placeholder()" [type]="type()" [required]="required()" [min]="min()" [max]="max()" [step]="step()" [errorStateMatcher]="errorStateMatcher()">
    @if (help()) {
      <mat-icon matSuffix [matTooltip]="help()" class="form-field__help-icon">help</mat-icon>
    }
    @if (isPassword()) {
      <button matIconButton matSuffix class="form-field__button" (click)="onShowPassword()">
        <mat-icon [matTooltip]="help()">{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    }
    <mat-error>{{error()}}</mat-error>
  </mat-form-field>
}
